export default __webpack_public_path__ + "static/woman-on-phone-cb2f974f22a71ebe9f8b09f63f624425.webp";